import { z } from 'zod/v4';

import { EntropyAuditSchema } from './audit.schema';
import { UserMemorySummarySchema } from './memory.schema';
import {
  CardCombinationSchema,
  CardInterpretationSchema,
  DrawnCardSchema,
  ReadingSchema,
  TriadCombinationSchema,
} from './reading.schema';
import { SpreadSchema } from './spreads.schema';
import { ReadingModeSchema } from './tarot.schema';
import {
  AppBootstrapConfigSchema,
  UserSessionSchema,
  WPBridgeConfigSchema,
  WPSessionSchema,
} from './wp.schema';
import { UserPreferencesSchema } from './user.schema';

export const DrawRequestSchema = z.object({
  spreadId: z.string().min(1),
  question: z.string().min(1),
  mode: ReadingModeSchema,
});

export const DrawResponseDTOSchema = z.object({
  cards: z.array(DrawnCardSchema),
  audit: EntropyAuditSchema,
});

export const DrawResponseSchema = DrawResponseDTOSchema;

export const InterpretRequestSchema = z.object({
  cards: z.array(DrawnCardSchema),
  spread: SpreadSchema,
  question: z.string().min(1),
  mode: ReadingModeSchema,
  withLLM: z.boolean(),
});

export const InterpretResponseDTOSchema = z.object({
  interpretations: z.array(CardInterpretationSchema),
  combinations: z.array(CardCombinationSchema),
  triads: z.array(TriadCombinationSchema),
  synthesis: z.string().min(1),
  llmResponse: z.string().min(1).nullable().optional(),
});

export const InterpretResponseSchema = InterpretResponseDTOSchema;

export const HistoryListResponseSchema = z.object({
  items: z.array(ReadingSchema),
  page: z.number().int().positive(),
  limit: z.number().int().positive(),
  total: z.number().int().nonnegative(),
});

export const MemoryResponseSchema = z.object({
  summary: UserMemorySummarySchema,
});

export const SessionResponseSchema = z.object({
  session: WPSessionSchema,
  config: WPBridgeConfigSchema,
});

// Existing block-0 frontend route placeholders still consume these DTOs directly.
export const SettingsResponseSchema = z.object({
  preferences: UserPreferencesSchema,
  featureFlags: AppBootstrapConfigSchema.shape.featureFlags,
  pluginSettings: z.object({
    appName: z.string().min(1),
    language: z.enum(['it', 'en']),
    ritualModeDefault: ReadingModeSchema,
    enableLilithMode: z.boolean(),
    enableKabbalahOverlay: z.boolean(),
    enableQliphothOverlay: z.boolean(),
    enablePwa: z.boolean(),
    cacheVersion: z.string().min(1),
  }),
});

export const SessionUserSchema = UserSessionSchema;
export const AppBootstrapSchema = AppBootstrapConfigSchema;
